import { Component, createRef } from 'react'
// this was originally from npm package react-to-print, but that resulted in
// buggy behavior in IE11. Manually importing a copy of the code works for now
// Hopefully, we can use the actual package again someday
import ReactToPrint from './ReactToPrint'
import PropTypes from 'prop-types'
import Panel from 'beam/dist/Panel'
import { MenuItem } from 'beam/dist/Menu'
import { ListItemText } from 'beam/dist/List'
import BeamIcon from 'beam/dist/BeamIcon'
import IconMenu from 'beam/dist/IconMenu'
import withStyles from 'beam/dist/styles'
import { withTranslation } from 'react-i18next'
import TranscriptionContent from './TranscriptionContent'
import ErrorBoundary from '../ErrorBoundary'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-Transcription-'

const styles = theme => ({
  panelBody: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
  },
})

class TranscriptionPanel extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    /** if the transcription data or the storage file is still being loaded */
    loading: PropTypes.bool.isRequired,
    /** if loading the transcription data failed for some reason */
    error: PropTypes.bool.isRequired,
    ccrid: PropTypes.number.isRequired,
    /** Result from the API */
    texts: PropTypes.arrayOf(
      PropTypes.shape({
        channel: PropTypes.number.isRequired,
        end: PropTypes.number.isRequired,
        hits: PropTypes.array.isRequired,
        start: PropTypes.number.isRequired,
        sentiment: PropTypes.number,
        text: PropTypes.string.isRequired,
        words: PropTypes.arrayOf(
          PropTypes.shape({
            hit: PropTypes.bool.isRequired,
            start: PropTypes.number.isRequired,
            word: PropTypes.string.isRequired,
          }),
        ),
      }),
    ),
  }

  state = {
    isSearchOpen: false,
  }

  printRef = createRef()

  createOpenSearchHandler(preOpenHandler = () => {}) {
    return () => {
      preOpenHandler()
      this.setState({ isSearchOpen: true })
    }
  }

  closeSearch() {
    this.setState({ isSearchOpen: false })
  }

  render() {
    const { t, classes, ...contentProps } = this.props
    const { loading, error, texts } = contentProps

    const noBubbles = loading || error || texts.length === 0

    return (
      <Panel
        titleIcon={<BeamIcon>ClipboardText</BeamIcon>}
        title={t('transcription')}
        dense
        variant="light"
        classes={{ body: classes.panelBody }}
        dataTestId={`${dataTestIdPrefix}panel`}
        headerTestId={`${dataTestIdPrefix}panel-heading`}
        headerActions={
          !noBubbles && (
            <IconMenu
              renderItems={closeMenu => [
                <MenuItem key="find" dense onClick={this.createOpenSearchHandler(closeMenu())}>
                  <ListItemText primary={t('find')} />
                </MenuItem>,
                <ReactToPrint
                  key="print"
                  trigger={() => (
                    <MenuItem dense>
                      <ListItemText primary={t('print')} />
                    </MenuItem>
                  )}
                  onBeforePrint={closeMenu()}
                  content={() => this.printRef.current}
                />,
              ]}
            />
          )
        }
      >
        <ErrorBoundary key={contentProps.ccrid}>
          <TranscriptionContent printRef={this.printRef} isSearchOpen={this.state.isSearchOpen} {...contentProps} />
        </ErrorBoundary>
      </Panel>
    )
  }
}

export { TranscriptionPanel as UnstyledTranscriptionPanel }
export default withTranslation()(withStyles(styles)(TranscriptionPanel))
